/*
 * Created on 13.10.2016
 *
 * Copyright(c) 1995 - 2016 T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 */

import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { AccordionPanel } from './accordion-panel.model';

/**
 * Diese Komponente ist eine interne Komponente welche ein Accordion implementiert .
 *
 * Usage:
 * <form-accordion [data]="eine liste Aus AccordionPanel" isTemplatePanel= " fals ein eigene template erwunscht
 * ist dann auf true setzen
 * sonst weg lassen"></form-accordion>
 *
 * panelTemplate ist das angegeben template und kötte so ausehen:
 *
 *   <template let-panel="panel">
 *        <div *ngIf="panel.title === 'Bewertung'">
 *            {{panel.content}} <span class="icon-clock"></span>
 *        </div>
 *    </template>
 *
 * @author imam
 * @author thm
 */

@Component({
    selector: 'form-accordion',
    templateUrl: 'accordion.component.html'
})
export class AccordionComponent {
    @Input() data: AccordionPanel[];
    @Input() isTemplatePanel = false;
    @ContentChild(TemplateRef) panelTemplate;


    collapse(panel: AccordionPanel) {
        this.data.forEach((pl: AccordionPanel) => {
            if (panel.name !== pl.name) {
                pl.collapsed = true;
            }
        });
        panel.collapsed = !panel.collapsed;

    }
}
